import { render, staticRenderFns } from "./HomeNewslist.vue?vue&type=template&id=f28e7aa2&scoped=true&"
import script from "./HomeNewslist.vue?vue&type=script&lang=ts&"
export * from "./HomeNewslist.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNewslist.vue?vue&type=style&index=0&id=f28e7aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e7aa2",
  null
  
)

export default component.exports